module.exports = __webpack_public_path__ + "static/media/20240715_104739.be2bf0a8.jpg";